// @flow

import { RECEIVED_FORM_SETTINGS } from './constants';
import type { ReceivedFormSettings } from './actions';

const initialState = {
  error_messages: {
    required: '',
    email: '',
    no_selection: '',
    phone: '',
    date: '',
    emails_not_equal: '',
    send_error: '',
  },

  // custom (filled by back-end):
  provinces: [],
  shops: [],
  income_sources: {},

  // settings:
  datum_from: '',
  datum_to: '',

  // labels:
  alternative_text: '',
  city_label: '',
  comfort_message: '',
  comment_label: '',
  comment_placeholder: '',
  date_of_birth_day: '',
  date_of_birth_label: '',
  date_of_birth_month: '',
  date_of_birth_year: '',
  email_check_label: '',
  email_check_placeholder: '',
  email_label: '',
  email_placeholder: '',
  first_name_label: '',
  form_title: '',
  house_number_label: '',
  house_number_placeholder: '',
  house_number_suffix_label: '',
  house_number_suffix_placeholder: '',
  income_source_label: '',
  initials: '',
  last_name_label: '',
  navigation_button_link: '',
  navigation_button_text: '',
  newsletter_text: '',
  out_of_stock_text: '',
  overlay_title: '',
  postal_code_and_house_number_label: '',
  postal_code_label: '',
  postal_code_placeholder: '',
  province_label: '',
  salutation_female: '',
  salutation_label: '',
  salutation_male: '',
  select_color_button_text: '',
  select_first_option_label: '',
  shop_label: '',
  street_label: '',
  submit_button_label: '',
  telephone_label: '',
  terms_label: '',
  terms_link: '',
  terms_link_text: '',
};

export type State = typeof initialState;

export default (state: State = initialState, action: ReceivedFormSettings): State => {
  switch (action.type) {
    case RECEIVED_FORM_SETTINGS:
      return {
        ...state,
        ...action.payload,
        income_sources: {
          ...action.payload.income_sources,
        },
      };
    default:
      return state;
  }
};
